import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "lnr-bag-coins FilterIcon" }, null, -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "Title" }, " Tuition Fee ", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "Badge"
}
const _hoisted_4 = { class: "RefineContentOptionsList" }
const _hoisted_5 = { class: "controlLabel" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Annual tuition fee ", -1 /* HOISTED */)
const _hoisted_7 = { class: "rangeContainer" }
const _hoisted_8 = { class: "formControl" }
const _hoisted_9 = { class: "SCTextInput" }
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Min", -1 /* HOISTED */)
const _hoisted_12 = { class: "SCTextInput" }
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Max", -1 /* HOISTED */)
const _hoisted_15 = { class: "sliderControl" }
const _hoisted_16 = ["step", "max"]
const _hoisted_17 = ["step", "max"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["TuitionFeeFilterWrapper", {'is-collapsed': _ctx.collapsed}])
  }, [
    _createElementVNode("header", {
      class: "RefineSectionHeading",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleFilter()))
    }, [
      _hoisted_1,
      _hoisted_2,
      (_ctx.filterHintCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.filterHintCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("i", {
        class: _normalizeClass(["ToggleIcon", [_ctx.collapsed ? 'lnr-chevron-down' : 'lnr-chevron-up']])
      }, null, 2 /* CLASS */)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, [
          _hoisted_6,
          _createTextVNode(),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeCurrencyClicked && _ctx.changeCurrencyClicked(...args)))
          }, _toDisplayString(_ctx.userCurrency), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("input", {
              value: _ctx.fromSelectedFormatted,
              onOnfocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateFromInputValue && _ctx.updateFromInputValue(...args))),
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateFromInputValue && _ctx.updateFromInputValue(...args))),
              inputmode: "numeric"
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_10),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("input", {
              value: _ctx.toSelectedFormatted,
              onOnfocusout: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateToInputValue && _ctx.updateToInputValue(...args))),
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateToInputValue && _ctx.updateToInputValue(...args))),
              inputmode: "numeric"
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_13),
            _hoisted_14
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            ref: "fromSlider",
            class: "fromSlider slider",
            step: _ctx.sliderStepSize,
            type: "range",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fromSelected) = $event)),
            min: "0",
            max: _ctx.maxValue,
            onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateFromInputValue && _ctx.updateFromInputValue(...args)))
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_16), [
            [_vModelText, _ctx.fromSelected]
          ]),
          _withDirectives(_createElementVNode("input", {
            ref: "toSlider",
            class: "toSlider slider",
            step: _ctx.sliderStepSize,
            type: "range",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.toSelected) = $event)),
            min: "0",
            max: _ctx.maxValue,
            onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateToInputValue && _ctx.updateToInputValue(...args)))
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_17), [
            [_vModelText, _ctx.toSelected]
          ])
        ])
      ])
    ])
  ], 2 /* CLASS */))
}